import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'

import { MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS } from '../../../../configs/translations'
import { MarketsExpandToggle } from '../marketsExpandToggle/MarketsExpandToggle'

const KEYS = MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS

interface IScopeColumnHeaderProps {
  scope: string
  isMarketView: boolean
  isMarketsExpanded: boolean
  onToggleMarketsExpanded: () => void
}

export const ScopeColumnHeader = ({
  scope,
  isMarketView,
  isMarketsExpanded,
  onToggleMarketsExpanded,
}: IScopeColumnHeaderProps) => {
  if (isMarketView) {
    return <>{scope}</>
  }

  return (
    <Flex justifyContent="space-between" alignItems="center" width="100%">
      <MarketsExpandToggle
        title={<Translation text={KEYS.table.worldwide} span />}
        isMarketsExpanded={isMarketsExpanded}
        onToggleMarketsExpanded={onToggleMarketsExpanded}
      />
    </Flex>
  )
}

ScopeColumnHeader.displayName = 'ScopeColumnHeader'
